export default __webpack_public_path__ + "static/media/blog5.9c947b75.png";